<template>
    <div class="w-100 align-self-start">
        <v-card flat color="transparent">
            <v-card-title class="d-block">
                <v-btn class="mb-3" small text color="secondary" :to="{ name: 'user-pools' }">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Resource Pools
                </v-btn>
                <div>Create wallet</div>
            </v-card-title>

            <v-card-text>
                <v-card flat style="max-width: 600px">
                    <v-card-text>
                        <v-form ref="form" v-model="formValid" @submit.prevent="submit">
                            <v-select
                                v-model="parentResourcePoolId"
                                :items="accountOptions"
                                item-text="long_id"
                                item-value="rpid"
                                label="Parent account"
                                outlined
                                dense
                                :rules="[rules.required]"
                                :loading="loadingAccounts"
                                :disabled="saving || loadingAccounts"
                                required></v-select>
                            <v-text-field
                                v-model="name"
                                label="Wallet name"
                                outlined
                                dense
                                :rules="[rules.required]"
                                :disabled="saving"
                                required></v-text-field>
                            <div class="d-flex justify-end mt-6">
                                <v-btn :disabled="!formValid || saving" :loading="saving" color="primary" text type="submit">Create</v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'UserPoolsCreateWallet',
    data() {
        return {
            formValid: false,
            saving: false,
            loadingAccounts: false,
            parentResourcePoolId: null,
            name: '',
            rules: {
                required: value => Boolean(String(value || '').trim()) || 'Field is required'
            }
        }
    },
    computed: {
        ...mapState('userStore', ['availableResourcePools']),
        accountOptions() {
            return this.availableResourcePools.filter(pool => String(pool.resource_pool_type || 'ACCOUNT').toUpperCase() === 'ACCOUNT')
        }
    },
    methods: {
        async fetchAccounts() {
            this.loadingAccounts = true
            try {
                const { data } = await this.$axios.get('/resource/available_rps')
                this.$store.commit('userStore/setAvailableResourcePoolData', data)
            } finally {
                this.loadingAccounts = false
            }
        },
        async submit() {
            if (!this.$refs.form || !this.$refs.form.validate()) {
                return
            }

            this.saving = true
            try {
                await this.$axios.post('/resource_pools', {
                    long_id: this.name.trim(),
                    parent_rpid: Number(this.parentResourcePoolId),
                    resource_pool_type: 'WALLET'
                })
                await this.$store.dispatch('userStore/fetchAvailableResourcePoolData')
                this.$store.dispatch('showSnackBar', {
                    snackBarText: 'Wallet created.',
                    snackBarTimeout: 5000,
                    snackBarIcon: 'check_circle'
                })
                this.$router.push({ name: 'user-pools' })
            } catch (error) {
                this.$store.dispatch('showSnackBar', {
                    snackBarText: error.response?.data?.debug || 'Could not create wallet.',
                    snackBarTimeout: 5000,
                    snackBarIcon: 'error'
                })
            } finally {
                this.saving = false
            }
        }
    },
    created() {
        this.fetchAccounts()
    }
}
</script>
